import { transformError as sdkTransformError } from '@wix/sdk-runtime/transform-error';
import {
  renameKeysFromSDKRequestToRESTRequest,
  renameKeysFromRESTResponseToSDKResponse,
} from '@wix/sdk-runtime/rename-all-nested-keys';
import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import * as ambassadorWixMetroinspectorV1Long from './metroinspector-v1-long-echo.http.js';

export interface LongMessage {
  int64Field?: string;
  uint64Field?: string;
  int64ValueField?: string | null;
  uint64ValueField?: string | null;
  sint64Field?: string;
  sfixed64Field?: string;
  fixed64Field?: string;
  durationField?: GoogleProtoDuration;
  _id?: string | null;
}

type GoogleProtoDuration = any;

/**
 * echo given arg1 and arg2
 * @public
 * @fqn wix.coreservices.longTypes.v1.LongTypesService.PublicLongEcho
 */
export async function publicLongEcho(
  options?: PublicLongEchoOptions
): Promise<
  NonNullablePaths<
    LongMessage,
    | `int64Field`
    | `uint64Field`
    | `sint64Field`
    | `sfixed64Field`
    | `fixed64Field`,
    2
  >
> {
  // @ts-ignore
  const { httpClient, sideEffects } = arguments[1] as {
    httpClient: HttpClient;
    sideEffects?: any;
  };

  const payload = renameKeysFromSDKRequestToRESTRequest({
    int64Field: options?.int64Field,
    uint64Field: options?.uint64Field,
    int64ValueField: options?.int64ValueField,
    uint64ValueField: options?.uint64ValueField,
    sint64Field: options?.sint64Field,
    sfixed64Field: options?.sfixed64Field,
    fixed64Field: options?.fixed64Field,
    durationField: options?.durationField,
    id: options?._id,
  });

  const reqOpts = ambassadorWixMetroinspectorV1Long.publicLongEcho(payload);

  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);

    return renameKeysFromRESTResponseToSDKResponse(result.data)!;
  } catch (err: any) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          int64Field: '$[0].int64Field',
          uint64Field: '$[0].uint64Field',
          int64ValueField: '$[0].int64ValueField',
          uint64ValueField: '$[0].uint64ValueField',
          sint64Field: '$[0].sint64Field',
          sfixed64Field: '$[0].sfixed64Field',
          fixed64Field: '$[0].fixed64Field',
          durationField: '$[0].durationField',
          id: '$[0]._id',
        },
        singleArgumentUnchanged: false,
      },
      ['options']
    );
    sideEffects?.onError?.(err);

    throw transformedError;
  }
}

export interface PublicLongEchoOptions {
  int64Field?: string;
  uint64Field?: string;
  int64ValueField?: string | null;
  uint64ValueField?: string | null;
  sint64Field?: string;
  sfixed64Field?: string;
  fixed64Field?: string;
  durationField?: GoogleProtoDuration;
  _id?: string | null;
}
